import asMyList from '../../components/asMyList.js';
import WineGBCatalog from './WineGBCatalog';
import WineGBCatalogPrintPreview from './WineGBCatalogPrintPreview';

// This follows the naming conventions from Classic
export const templates = {
  'brn:print:5af58c2b5c4a53e2d0e59c25:uk.co.winegb.catalogue':
    asMyList(WineGBCatalog),
  'brn:print:5af58c2b5c4a53e2d0e59c25:uk.co.winegb.cataloguePrintPreview':
    asMyList(WineGBCatalogPrintPreview),
};
